/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Removed_From_Group_SuccessInputs */



/**
* | output |
* | --- |
* | "User removed from group successfully" |
*
* @param {Team_Manager_User_Removed_From_Group_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_removed_from_group_success = /** @type {((inputs?: Team_Manager_User_Removed_From_Group_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Removed_From_Group_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisateur retiré du groupe avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer erfolgreich aus der Gruppe entfernt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utente rimosso dal gruppo con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользователь успешно удален из группы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usuario eliminado del grupo exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户已成功从群组中移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーはグループから正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता को समूह से सफलतापूर्वक हटा दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usuário removido do grupo com sucesso")
	return /** @type {LocalizedString} */ ("User removed from group successfully")
});